import { render, staticRenderFns } from "./semanticBot.vue?vue&type=template&id=6be2774c&lang=html&"
import script from "./semanticBot.vue?vue&type=script&lang=js&"
export * from "./semanticBot.vue?vue&type=script&lang=js&"
import style0 from "./semanticBot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports